<template>
    <div class="must-have-exactly-one-root-element">

        <!-- Header -->
        <header-login/>

        <!-- Main -->
        <main class="registerScreen">
            <div class="container-fluid">
                <div class="row --mainRow">
                    <!-- Left img -->
                    <div class="col-xs-12 col-md-4 col-lg-4 col-xl-6 d-none d-xl-block --loginBg leftCol"></div>

                    <!-- Registrácia -->
                    <div class="col-xs-12 col-md-12 col-lg-12 col-xl-6 rightCol">
                        <div class="paddingBox">
                            <h2>Registrácia</h2>
                            <p>
                                Ďakujeme za váš záujem zaregistrovať triedu vašej základnej školy alebo škôlky do školskej súťaže Adoptuj kravičku o hodnotné ceny.
                                Registrácia bude spustená 1.9.2021.
                            </p>
                            <p>Sledujte náš <a href="https://www.facebook.com/AdoptujKravicku" target="_blank">facebookový účet</a> pre viac informácií.</p>
                        </div>
                    </div>
                    <!-- .Registrácia -->

                </div>
            </div>
        </main>
        <!-- .Main -->

    </div>
</template>



<script>
    import EventService from '@/services/EventService.js'
    import HeaderLogin  from './partials/HeaderLogin.vue'
    import json         from '@/services/okresy.json'
    export default {
        components: {
            HeaderLogin
        },
        mounted() {
            this.emitResetProfil()
        },
        data() {
            return {
                okresy: json,

                active0: ' active',
                active1: '',

                meno: '',
                email: '',
                heslo: '',
                okres: json[0].name,
                suhlas1: '',
                suhlas2: '',
                suhlas3: '',
                skupina: '',

                responseType: '',
                responseText: ''
            }
        },
        methods: {
            // emit
            emitResetProfil() {
                this.$emit('resetProfil')
            },


            // select
            onChange(value) {
                this.okres = value
            },


            // submit
            formSubmit(e) {
                e.preventDefault()
                document.getElementById("scrollReg").scrollIntoView()
                this.register()
            },

            register() {
                EventService.register(this.meno, this.email, this.heslo, this.okres, this.suhlas1, this.suhlas2, this.suhlas3, this.skupina)
                    .then(response => {
                        //console.log(response.data)
                        this.responseType = response.data.code
                        this.responseText = response.data.data

                        this.$gtm.trackEvent({
                            event: 'Registration',
                            category: 'form',
                            action: 'submit',
                            label: 'registration',
                            value: 'successful',
                        });

                        if (response.data.code == 'success') {
                            // nemáme token takže ho nevieme automaticky prihlásiť
                            //EventService.saveTokenToSession(response.data.data.token)
                            //this.$router.push({ name: 'profil' })
                        }
                    })
                    .catch(error => {
                        this.responseType = 'warning'
                        this.responseText = error
                    })
            },


            // click
            regType(typ) {
                if (typ == 'jednotlivec') {
                    this.active0 = ' active'
                    this.active1 = ''
                    this.skupina = 0
                } else {
                    this.active0 = ''
                    this.active1 = ' active'
                    this.skupina = 1
                }
            },

            fbLogin() {
                // window.location.replace("https://www.adoptujkravicku.sk/hra/")
                let self = this
                FB.login(function(response) {
                    if (response.authResponse) {

                        FB.api('/me', {fields: 'name, email'}, function(userData) {
                            EventService.fbLogin(userData)
                                .then(response => {
                                    self.initAcl()
                                    EventService.saveTokenToSession(response.data.data.access_token)
                                    sessionStorage.setItem("login", "success")
                                    self.$router.push({ name: 'profil' })
                                })
                                .catch(error => {
                                    self.responseType = 'warning'
                                    self.responseText = error
                                })
                        });

                    } else {
                        console.log('User cancelled login or did not fully authorize.');
                    }
                },  { scope: 'email' });
            },

            initAcl() {
                EventService.initializeAcl()
                    .then(response => {
                        console.log(response)
                    })
                    .catch(error => {
                        this.responseType = 'warning'
                        this.responseText = error
                    })
            },
        }
    }
</script>
